import swal from 'sweetalert';
import JQueryView, { on } from '@/common/views/jqueryView';

export default class FundingView extends JQueryView {
  constructor() {
    super('#funding_view');
  }

  @on({ event: 'click', selector: '.submit' })
  onClickSubmit() {
    swal({
      title: '事業者登録が完了しないとお申込みできません',
      confirmButtonColor: '#2196F3',
      animation: false,
    });
  }
}
